/** The Documentation section (ADR-0080): every signed-in role. */
export const RELEASE_NOTES_PATH = "/documentation/release-notes";
export const CUSTOMER_DOCUMENTS_PATH = "/documentation/customer";
